/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Run_StageInputs */

const cs_property_ai_run_stage = /** @type {(inputs: Property_Ai_Run_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spustit staging`)
};

const en_property_ai_run_stage = /** @type {(inputs: Property_Ai_Run_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run staging`)
};

/**
* | output |
* | --- |
* | "Run staging" |
*
* @param {Property_Ai_Run_StageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_run_stage = /** @type {((inputs?: Property_Ai_Run_StageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Run_StageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_run_stage(inputs)
	return cs_property_ai_run_stage(inputs)
});